/* eslint-disable */
import { getFirestore, doc, addDoc, getDoc, getDocs, setDoc, collection, query, where, orderBy } from 'firebase/firestore'
import Group from '@/models/group'

export default class Guest {
  constructor(id, name, groupId, dietary, rsvp, created, updated) {
    // Constructor should only be used internally by this class.
    this.id = id
    this.name = name
    this.dietary = dietary
    this.rsvp = rsvp
    this.group = undefined // Populated on `load()`.
    this.created = created // Only updated on `create()`.
    this.updated = updated // Updated only on `save()`.
    this._groupId = groupId
    this._ref = this.ref
    this._collection = this.collection
  }

  toString() {
    return 'Guest ('
      + this.id + ', '
      + this.name + ', '
      + this._groupId + ', '
      + this.dietary + ')'
  }

  static firestoreConverter() {
    return {
      toFirestore: (guest) => {
        return {
          name: guest.name,
          group: doc(getFirestore(), 'groups', guest._groupId) ?? null,
          dietary: guest.dietary ?? null,
          rsvp: guest.rsvp ?? null,
          created: guest.created,
          updated: new Date(),
        }
      },
      fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        return new Guest(
          snapshot.id,
          data.name,
          data.group.path?.split('/')[1] ?? null,
          data.dietary,
          data.rsvp ?? null,
          data.created.toDate(),
          data.updated.toDate(),
        )
      }
    }
  }

  get ref() {
    if (!this.id) return null
    if (!this._ref) {
      this._ref = doc(getFirestore(), 'guests', this.id).withConverter(Guest.firestoreConverter())
    }
    return this._ref
  }

  get collection() {
    if (!this._collection) {
      this._collection = collection(getFirestore(), 'guests').withConverter(Guest.firestoreConverter())
    }
    return this._collection
  }

  static async create(name, groupId) {
    if (!name) {
      throw new Error('A name is required to create a guest.')
    }

    const guest = new Guest(null, name, groupId, undefined, undefined, new Date())
    const ref = await addDoc(guest.collection, guest)
    guest.id = ref.id
    return guest
  }

  static async search(name) {
    const query = query(this.collection, where('name', 'CONTAINS', name))
    const snap = await getDocs(query)
    return snap.docs.map(doc => doc.data())
  }

  async load() {
    const snap = await getDoc(this.ref)
    const result = snap.data()
    if (!result) return false

    this.name = result.name
    this._groupId = result._groupId
    this.group = await Group.get(this._groupId)
    this.dietary = result.dietary
    this.rsvp = result.rsvp
    this.created = result.created
    this.updated = result.updated
    return true
  }

  async save() {
    return await setDoc(this.ref, this, {merge: true})
  }

  static async getGroupMembers(groupRef) {
    const guest = new Guest()
    const q = query(await guest.collection, where('group', '==', groupRef), orderBy('created', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map(doc => doc.data())
  }

  // static async getAll() {
  //   const guest = new Guest()
  //   const snap = await getDocs(guest.collection)
  //   const all = snap.docs.map(doc => doc.data())
  //   return await Promise.all(
  //     all.map(async g => {
  //       await g.load()
  //       return g
  //     })
  //   )
  // }
}